'use client';

import dynamic from 'next/dynamic';
import { FC } from 'react';

// pdf.js touches DOM APIs on import, so the viewer is client-only.
const Viewer = dynamic(() => import('./Viewer'), { ssr: false });

const ManufacturingDeck: FC = () => <Viewer />;

export default ManufacturingDeck;
